module.exports = __webpack_public_path__ + "img/subcontracts_resultbanner.7efcdc9c.png";